// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__TrrWS","toolbar":"Admin_toolbar__dmuUt","settings":"Admin_settings__qYwEx"};